import { useMutation } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { client } from '@cast/core';
import { notify } from '@cast/design-system';

type DeleteAllFixturesInput = {
  fixturesGroup: string;
};

export const useDeleteAllFixturesMutation = () => {
  return useMutation({
    mutationFn: async ({ fixturesGroup }: DeleteAllFixturesInput) => {
      return client.delete(`/dev-tools/recorder/${fixturesGroup}`, {
        data: {},
        baseURL: '',
      });
    },
    onSuccess: () => {
      notify.success('All static fixtures deleted successfully!');
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
